import React from 'react';
import Drawer from '../../../../components/Drawer/Drawer';
import Img from '../../../../components/Img/Img';
import './RecommendSearchInfoDrawer.scss';

const RecommendSearchInfoDrawer = (props) => {
  const { title, visible, onClose, imgUrl, children } = props;

  return (
    <Drawer className="recommend-search-info-drawer" title={title} visible={visible} onClose={onClose}>
      <Img clickAble={false} src={imgUrl} />

      <div className="recommend-search-info-text">{children}</div>
    </Drawer>
  );
};

export default RecommendSearchInfoDrawer;
